import {Injectable} from "@angular/core";
import {DataSource} from "@angular/cdk/collections";
import {BehaviorSubject, Observable} from "rxjs";
import {IInventoryItemV2} from "./interfaces/inventory-item.interface";
import {ShopItemsService} from "./shop-items.service";
import {IGetShopItems} from "./interfaces/get-shop-items.interface";


@Injectable()
export class ShopItemsDataSource extends DataSource<IInventoryItemV2> {

  shopItems$: BehaviorSubject<IInventoryItemV2[]> = new BehaviorSubject<IInventoryItemV2[]>([]);

  isLoading$: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
  totalCount!: number;

  constructor(private shopItemsService: ShopItemsService) {
    super();
  }

  connect(): Observable<IInventoryItemV2[]> {
    return this.shopItems$.asObservable();
  }

  disconnect() {
    this.shopItems$.complete();
  }

  loadData(page: number, size: number, params: any): void {
    const offset: number = page * size;
    this.isLoading$.next(true);
    const body: IGetShopItems = {
      appId: 730,
      pagination: {
        limit: size,
        offset
      },
      ...params,
    }

    this.shopItemsService.getShopItems(body)
      .subscribe((shopItems: { items: IInventoryItemV2[]; count: number }) => {
        this.shopItems$.next(shopItems.items);
        this.totalCount = shopItems.count;
        this.isLoading$.next(false);
      });
  }
}
